<template>
  <a-card :bordered="false" title="补差助手">
    <a-card :bordered="false">
      <search-page-view
        :itemNames="['search_name','search_state']"
        :col="4"
        ref="pageList"
        :buttonItems="['add-button']"
        rowKey="complementId"
        query-path="complement/findComplementOrderList"
        base-key="serviceUrl"
        :queryParams="queryParams"
        :buttonCol="2"
        :columns="columns"
      >
        <a-form-item slot="search_name" label="补差订单" v-bind="searchItemLayout">
          <a-input v-model="queryParams.complementNo" placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item slot="search_state" label="支付状态" v-bind="searchItemLayout">
          <a-select
            style="width: 100%"
            v-model="queryParams.complementStatus"
            placeholder="请选择"
          >
            <a-select-option v-for="item in proCategoryList" :key="item.code" :value="item.code">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-button slot="add-button" style="margin-left: 8px" @click="openFoundCompensation(1)">创建补差</a-button>
        <a-button slot="add-button" style="margin-left: 8px" @click="openFoundCompensation(2)">补差设置</a-button>
        <span slot="number" slot-scope="rowItem">
      {{ rowItem.record.usedNum }}/{{ rowItem.record.stockNum }}
    </span>
        <span slot="action" slot-scope="rowItem" v-if="rowItem.record.complementStatus == 0">
        <a @click="openFoundCompensation(1,rowItem)">编辑</a>
        <a-divider type="vertical"></a-divider>
        <a @click="toEditor(rowItem)">分享</a>
        <a-divider type="vertical"></a-divider>
        <a-popconfirm
          title="是否要关闭当前订单？"
          @confirm="deleteEvent(rowItem)">
            <a>关闭</a>
        </a-popconfirm>
    </span>
      </search-page-view>
    </a-card>
    <a-modal
      :title="title"
      :width="500"
      v-model="visible"
      @ok="foundCompensation"
      @cancel="visible=false"
      :destroyOnClose='true'
    >
      <a-form :form="form">
        <a-form-item label="订单号" v-bind="customFormItemLayout" v-if="showDialog == 1">
          <a-input
            style="width:300px"
            v-decorator="['complement_No', {rules:[{required: true, message:'请输订单号'}],validateTrigger: 'change,blur'}]"
            placeholder="请输订单号"
          ></a-input>
        </a-form-item>
        <a-form-item label="补差金额" v-bind="customFormItemLayout" v-if="showDialog == 1">
          <a-input-number
            style="width:300px"
            :min="0"
            placeholder="请输入补差金额"
            v-decorator="['complement_Amount', {rules: [{required: true,validator: handleMoney}], validateTrigger: [ 'blur']}]"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="订单号" v-bind="customFormItemLayout" v-if="showDialog == 2">
          <a-checkbox defaultChecked disabled>一级运营商</a-checkbox>
          <a-checkbox @change="onChange" v-model="isCheck">二级运营商</a-checkbox>
        </a-form-item>

      </a-form>
    </a-modal>
    <a-modal
      title="复制链接"
      :width="500"
      v-model="visibleLink"
      @cancel="visibleLink=false"
      :destroyOnClose='true'
      :footer="null"
    >
      <a-textarea
        v-model="url"
        :autoSize="{ minRows: 3, maxRows: 5 }"
      />
      <a-button
        v-clipboard:copy="url"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        style="margin-top:20px" type="primary">复制
      </a-button>
    </a-modal>
  </a-card>
</template>

<script>
import SkipOtherHelper from '../../../../utils/helper/SkipOtherHelper'
import searchForm from '../../../../utils/mixins/searchFormMixins'

export default {
  name: 'ComplementHelper',
  mixins: [searchForm],
  data() {
    return {
      proCategoryList: [
        {
          name: '全部',
          code: ''
        },
        {
          name: '待支付',
          code: '0'
        },
        {
          name: '已支付',
          code: '1'
        },
        {
          name: '已关闭',
          code: '3'
        }
      ],
      dropReasonList: [],
      queryParams: {},
      columns: [
        {
          title: '订单号',
          dataIndex: 'complementNo',
          width: '200px'
        },
        {
          title: '补差金额',
          dataIndex: 'complementAmount',
          width: '100px'
        },
        {
          title: '订单状态',
          dataIndex: 'complementStatusStr',
          width: '100px'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '创建人',
          dataIndex: 'createMen',
          width: '160px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      form: this.$form.createForm(this),
      visible: false,
      visibleLink: false,
      customFormItemLayout: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 15
        }
      },
      title: '',//创建补差
      showDialog: 1,
      url: 'aaaaabb',
      isCheck: false,
      icomplementId: 0,
      icloseComplement: false
    }
  },
  created() {

  },
  mounted() {
    this.queryParams.merchantId = this.$store.getters.userInfo.merchantId
    this.queryParams.platformId = this.getPlatformConfig().platformId
    //this.proCategoryList=this.getAppConstants().getProductTypeList();
    // this.dropReasonList=this.getAppConstants().getProInfoDropReason();
  },
  methods: {
    handleMoney(rule, value, callback) {
      let re = /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/ //两位正小数
      if (re.test(value)) {
        callback()
      } else {
        callback(new Error('补差金额有误'))
      }
    },
    //创建补差
    foundCompensation(e) {
      e.preventDefault()
      var that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          if (that.showDialog == 1) {
            that.modifyComplementOrder(that.icomplementId, values.complement_Amount, values.complement_No, that.icloseComplement)
          } else {
            that.modifyComplement()
          }
        }
      })
    },
    modifyComplement() { //设置补差
      let params = {
        merchantId: this.queryParams.merchantId,
        platformId: this.queryParams.platformId,
        permissionFlagStaff: this.isCheck
      }
      let url = this.getHttpServices().getTargetUrl('complement/modifyComplementPermission', params)
      this.getHttpServices().getServerApiService().post(url)
        .then(res => {
          this.$message.success('设置成功')
          this.visible = false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    modifyComplementOrder(complementId, payment, orderNo, closeComplement) { //创建/编辑补差
      let params = {
        complementNo: orderNo,
        merchantId: this.queryParams.merchantId,
        platformId: this.queryParams.platformId,
        closeComplement: closeComplement,
        complementAmount: payment,
        complementId: complementId
      }
      this.getHttpServices().getServerApiService().post('complement/modifyComplementOrder', params)
        .then(res => {
          this.$message.success('创建成功')
          this.visible = false
          this.$refs.pageList.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    openFoundCompensation(n, val) { //编辑 创建 设置
      if (n == 2) {
        let params = {
          merchantId: this.queryParams.merchantId,
          platformId: this.queryParams.platformId
        }
        this.getHttpServices().getServerApiService().get('complement/findComplementPermission', params)
          .then(res => {
            this.visible = true
            this.title = '补差设置'
            this.showDialog = 2
            this.isCheck = res
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.visible = true
        this.title = '创建补差'
        this.showDialog = 1
        this.icomplementId = 0
        this.icloseComplement = false
        if (val) {
          this.icomplementId = val.record.complementId
          this.$nextTick(() => {
            this.form.setFieldsValue({
              complement_No: val.record.complementNo,
              complement_Amount: val.record.complementAmount
            })
          })
        }

      }
    },
    onChange(e) {
      this.isCheck = e.target.checked
    },
    toEditor(rowItem) { //分享
      this.visibleLink = true
      this.url = rowItem.record.complementUrl
    },
    onCopy(e) {
      this.$message.success('复制成功')
      this.visibleLink = false
    },
    onError(e) {
      this.$message.error('复制失败')
      this.visibleLink = false
    },
    deleteEvent(rowItem) {//关闭当前订单
      this.modifyComplementOrder(rowItem.record.complementId, 0, rowItem.record.complementNo, true)
    }
  }
}
</script>
<style scoped>
</style>